import React from "react";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionAdditionalInfo({
  childrenOrDependents,
  handleChildrenOrDependentsChange,
  currentLivingArrangements,
  handleCurrentLivingArrangementsChange,
  dietaryRequirements,
  handleDietaryRequirementsChange,
  fundingSource,
  handleFundingSourceChange,
}) {
  return (
    <section className="pre-admission-additional-card">
      <div className="pre-admission-section-heading">
        <span className="pre-admission-section-kicker">Client context</span>
        <h2>Additional information</h2>
        <p>Living arrangements, dietary needs and funding</p>
      </div>
      <div className="pre-admission-additional-grid">
        <TextFieldComponentLarge title="Childrens or dependents" value={childrenOrDependents} onChange={handleChildrenOrDependentsChange} showValidation={true} />
        <TextFieldComponentLarge title="Current living arrangments" value={currentLivingArrangements} onChange={handleCurrentLivingArrangementsChange} showValidation={true} />
        <TextFieldComponentLarge title="Dietary requierements" value={dietaryRequirements} onChange={handleDietaryRequirementsChange} showValidation={true} />
        <TextFieldComponentLarge title="Funding Source" value={fundingSource} onChange={handleFundingSourceChange} showValidation={true} />
      </div>
    </section>
  );
}

export default AdmissionAdditionalInfo;

